import styled from "styled-components";

const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export default Page;
